export default "__VITE_ASSET__DJbEeg04__"